<template>
	<v-modal>
		<template v-slot:header>
			<h1>Add A {{ $present("ucWords", type) }}</h1>
		</template>
		<form @submit.prevent="add">
			<label class="inline"><span v-html="$present('ucWords', type)"/>
				<select v-model="item">
					<option disabled selected value="">—</option>
					<option
						v-for="(item, itemIndex) in items" :key="itemIndex" :value="item"
						v-html="feeName(item)"/>
					<option :value="null">Other</option>
				</select>
			</label>
			<label v-if="item === null"><span>{{ $present("ucWords", type) }} Name </span>
				<input
					v-model="name"
					type="text"/>
			</label>
			<label class="inline"><span>Value </span>
				<input
					v-model="value"
					class="number--thousands" min="0.01" step="0.01"
					type="number"/>
			</label>
		</form>
		<template v-slot:footer>
			<ul class="actions">
				<li>
					<button
						class="button button--primary" @click.prevent="add()">Add {{ $present("ucWords", type) }}
					</button>
				</li>
			</ul>
		</template>
	</v-modal>
</template>
<script>
export default {
	data() {
		return {
			item: "",
			name: "",
			value: "",
		};
	},

	computed: {
		items() {
			let items = {
				fee: {
					fee_telegraphic_transfer: ["sale", "purchase", "remortgage"],
					fee_leasehold_property: ["sale", "purchase", "remortgage"],
					fee_islamic_mortgage: ["sale", "purchase", "remortgage"],
					fee_new_build: ["purchase"],
					fee_shared_ownership: ["sale", "purchase", "remortgage"],
					fee_right_to_buy: ["purchase"],
					fee_transfer_of_equity: ["sale", "purchase", "remortgage"],
					fee_auction_repossession: ["sale", "purchase"],
					fee_help_to_buy_scheme: ["sale", "purchase"],
					fee_help_to_buy_isa: ["sale", "purchase"],
					fee_stamp_duty_form: ["purchase"],
					fee_mortgage_admin: ["sale", "purchase"],
					fee_lawyer_checker: ["sale", "purchase", "remortgage"],
					fee_buy_to_let: ["sale", "purchase", "remortgage"],
					fee_file_admin: ["sale", "purchase", "remortgage"],
					fee_lender_monitor: ["sale", "purchase", "remortgage"],
				},
				disbursement: {
					disbursement_search_pack: ["purchase"],
					disbursement_bankruptcy_search: ["purchase", "remortgage"],
					disbursement_id_check: ["sale", "purchase", "remortgage"],
					disbursement_office_copies_title_plan: ["sale", "purchase", "remortgage"],
					disbursement_land_registry_pre_completion: ["purchase", "remortgage"],
					disbursement_remortgage_search_policy: ["remortgage"],
				},
			};

			return _.keys(_.pickBy(items[this.type], transactions => {
				return transactions.indexOf(this.transaction) > -1;
			}));
		},
	},

	props: {
		transaction: {
			required: true,
			type: String,
		},
		type: {
			required: true,
			type: String,
		},
		quoteForm: {
			required: true,
			type: Object,
		},
		feeName: {
			required: true,
			type: Function,
		},
		set: {
			required: true,
			type: Function,
		},
	},

	methods: {
		add() {
			let name = this.item || this.name;
			let field = "calculation." + this.transaction + "." + this.type + "s";
			this.set(field, this.value, name);
			this.$vmodal.close();
		},
	},
};
</script>
